// export const urlcode = 'http://192.168.190.9:1024/sj'
// export const urlcode = 'http://192.168.190.194:10110/jccs-im/sj'
// export const urlcode = 'https://test.yfzmz01.com/sj'// 测试环境
export const urlcode = 'https://zys.yfzmz01.com/sj'// 正式环境

// websocket配置
// export const websocketUrl = 'wss://test.yfzmz01.com/sj' // 测试环境
export const websocketUrl = 'wss://zys.yfzmz01.com/sj' // 正式环境

export const timcofig = {
  SDKAPPID: 1600090291,
  userSig: "",
}

export default {timcofig, urlcode, websocketUrl}



// WEBPACK FOOTER //
// ./src/config.js